// flight.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Airport, FlightFootprintResponse } from 'src/app/shared/models/interfaces';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FlightService {
  private cabinClassLabels: { [label: string]: string } = {
    Economy: 'economy',
    'Premium Economy': 'premium_economy',
    Business: 'business',
    'First Class': 'first',
  };

  constructor(private http: HttpClient) {}

  searchAirports(query: string): Observable<Airport[]> {
    if (!query || query.length < 2) return of([]);
    return this.http.get<Airport[]>(
      `${environment.api}/flights/airports?q=${encodeURIComponent(query)}`
    );
  }

  airportDisplay(airport: Airport | string): string {
    if (!airport) return '';
    return typeof airport === 'string'
      ? airport
      : `${airport.name} (${airport.iata}) - ${airport.country}`;
  }

  getFlightFootprint(
    segments: { departureAirport: string; destinationAirport: string }[],
    cabinClass: 'economy' | 'premium_economy' | 'business' | 'first'
  ): Observable<FlightFootprintResponse> {
    const payload = {
      segments,
      cabinClass,
    };

    // Der Aufruf geht an eigenen Backend-Endpunkt
    return this.http
      .post<FlightFootprintResponse>(
        `${environment.api}/flights/flight-footprint`,
        payload
      )
      .pipe(
        map((response) => response),
        catchError((error) => {
          console.error('Error fetching flight footprint from backend:', error);
          throw error;
        })
      );
  }

  getCabinOptions(): string[] {
    return Object.keys(this.cabinClassLabels);
  }
}
